/*
 * @Description:
 * @Author: kangkang
 * @Date: 2022-06-26 22:24:06
 * @LastEditTime: 2023-04-10 22:25:48
 * @LastEditors: kangkang
 * @Reference:
 */
// const Main = () => import("@/views/main.vue");

const Home = () => import("@/views/index");
const Error = () => import("@/views/index/error");
const Record = () => import("@/views/index/record");
const Order = () => import("@/views/index/order");
const Video = () => import("@/views/index/video");
const PreVideo = () => import("@/views/index/prevideo");
export default [
    {
        path: "/index",
        name: "index",
        component: Home,
        meta: {
            name: "首页",
            iconType: "",
        },
    },
    {
        path: "/error",
        name: "error",
        component: Error,
        meta: {
            name: "错误",
            iconType: "",
        },
    },
    {
        path: "/record",
        name: "record",
        component: Record,
        meta: {
            name: "信息录入",
            iconType: "",
        },
    },
    {
        path: "/order",
        name: "order",
        component: Order,
        meta: {
            name: "订单信息",
            iconType: "",
        },
    },
    {
        path: "/video",
        name: "video",
        component: Video,
        meta: {
            name: "观看视频",
            iconType: "",
        },
    },
    {
        path: "/prevideo",
        name: "prevideo",
        component: PreVideo,
        meta: {
            name: "预览视频",
            iconType: "",
        },
    }
];
